<template>
  <div>
    <community :data="com_par" :title="title[1]"/>
    <financial :data="fin_anc" :title="title[2]" :lst_acc="lst_acc"/>
  </div>
</template>

<script>
import Community from '@/components/ascf/sharedCom/community.vue'
import Financial from '@/components/ascf/sharedCom/financial.vue'

export default {
  props: ["title", "com_par", "fin_anc", "lst_acc"],
  components: {
    'community': Community,
    'financial': Financial
  },
  data () {
    return {

    }
  }
}
</script>
<style scoped>

</style>